<template>
	<div class="content">
		<div class="intro">
			<div class="abouttitle">
				<h3>KA儿童之家介绍</h3>
				<img src="../assets/aboutus/introduction_to_ka.png" alt="">
			</div>
			<div class="intro-cont">
				<div class="cwidth">
					<img src="../assets/aboutus/intro_img.jpg" alt="">
					<div class="intro-cont-txt">
						<p>KA儿童之家是Etonkids北京伊顿国际幼儿园旗下品牌2017KA儿童之家正式上线，KA规模化总结和梳理了Etonkids17年高端园所运营管理经验、旨在将Etonkids17年自营高端园所的优秀教学内容和教育服务惠及到国内广大幼儿园</p>
						<p>KA儿童之家致力于成为一家汇聚全球优质教育资源，通过丰富的行业实践以优质的内容、管理和技术服务为驱动的幼教互联网平台。希望通过自主研发的七大产品体系，为园所输送国际化，品质化，个性化的产品和服务</p>
						<p>同时为了满足更多园所对于优质教学资源的需求，KA儿童之家将通过自主研发及国际合作的方式将各类特色课程、教学产品、游学产品提供给广大的中国幼儿园</p>
						<p>更重要的是，KA儿童之家将通过能够覆盖园所，老师，家长三端的互联网平台，全面赋能幼教行业，大幅度提升园所的运营管理水平，老师的专业素养以及家长的育儿水平。</p>
					</div>
				</div>
			</div>
		</div>
		<div class="story">
			<div class="abouttitle">
				<h3>品牌故事</h3>
				<img src="../assets/aboutus/brand_story.png" alt="">
			</div>
			<ul class="story-cont">
				<li class="story-cont-l">
					<div class="l-one">
						<h4>2002年由王伟（Vivien Wang）女士发起</h4>
						<p>美国哈佛大学、美国西北大学凯洛格商学院校友会成员联合创办了Etonkids 并将纯正的蒙台梭利教育法引入中国 经过17年的发展，已在全国17个省市拥有51家直营幼儿园，在校儿童数超过10000人，已经成为引领中国幼教国际发展的旗舰。</p>
					</div>
					<div class="l-two">
						<h4>重磅推出Kid Academy儿童之家-幼教平台</h4>
						<p>2017KA儿童规模化总结和梳理了Etonkids17年高端园所运营管理经验、重磅推出了儿童之家幼教合伙人平台 旨在将Etonkids17年自营高端园所的优秀教学内容和教育服务惠及到国内广大幼儿园</p>
					</div>
					<div class="l-thr">
						<h4>3月KA将正式发布KA线上三端产品</h4>
						<p>通过互联网的产品和平台 全面赋能幼教行业 大幅度提升园所的运营管理水平 老师的专业素养及家长的育儿水平</p>
					</div>
				</li>
				<li class="story-cont-r">
					<div class="r-one">
						<h4>推出首个国际化高端家长培训品牌Etonkids家长大学</h4>
						<p>将国际先进的幼教理念及实践引入国内</p>
					</div>
					<div class="r-two">
						<h4>KA特色课程服务在亚洲最大北教展首次亮相</h4>
						<p>旨在为园所提供优质的特色课程一站式解决方案</p>
					</div>
				</li>
			</ul>
		</div>
		<div class="adv">
			<div class="abouttitle">
				<h3>8大品牌优势</h3>
				<img src="../assets/aboutus/eight_brand_advantages.png" alt="">
			</div>
			<div class="adv-cont">
				<ul class="adv-cont-l">
					<li><img src="../assets/aboutus/1.png" alt="" class="pos1"><p class="font-red"><span>10000+</span>园所正在使用膳食营养体系</p></li>
					<li><img src="../assets/aboutus/3.png" alt="" class="pos2"><p class="font-blue">全国 <span>17个</span> 城市 <span>51个</span>中高端园所的运营管理经验</p></li>
					<li><img src="../assets/aboutus/5.png" alt="" class="pos3"><p class="font-yellow">全国<span>23个</span>城市，<span>40个</span>KA园所的整体解决方案经验</p></li>
					<li><img src="../assets/aboutus/7.png" alt="" class="pos4"><p class="font-purple"><span>AMS认证</span>机构 且拥有实践的基地</p></li>
				</ul>
				<ul class="adv-cont-r">
					<li><img src="../assets/aboutus/2.png" alt="" class="pos1"><p class="font-red">来自Etonkids国际幼儿园<span>17年</span>的优质教育资源</p></li>
					<li><img src="../assets/aboutus/4.png" alt="" class="pos2"><p class="font-blue"><span>一流</span> 的国内外专家、<span>国际认证资质</span>的教师及研发团队</p></li>
					<li><img src="../assets/aboutus/6.png" alt="" class="pos3"><p class="font-yellow"><span>哈佛大学、</span><span>斯坦福大学</span>和<span>西北大学</span>联合资源支持</p></li>
					<li><img src="../assets/aboutus/8.png" alt="" class="pos4"><p class="font-purple"><span>幼教内容</span>与<span>互联网</span>深度结合的赋能产品体系</p></li>
				</ul>
			</div>
		</div>
		<div class="concept">
			<div class="abouttitle">
				<h3>教育理念</h3>
				<img src="../assets/aboutus/educational_concept.png" alt="">
			</div>
			<div class="concept-thrc">
				<h5>3C价值教育理念</h5>
				<p><span class="font18">品格：</span>诚实、正直、尊重、富有同理心和责任心、宽容和坚毅自信这些都是成就个人健全品格的基础要求</p>
				<p><span class="font18">多元文化：</span>注重培养孩子独立思考的能力、主动分析问题并寻找其中最佳解决方案的能力</p>
				<p><span class="font18">创造力：</span>孩子未来的成功，不仅需要他们熟知本土生活环境，还要更多的了解国际环境下的多种文化</p>
			</div>
			<div class="concept-five">
				<h5>“5大”特质塑造</h5>
				<p>自主的学习者、机敏的思考者、有创造力的问题解决者、有同理心的小公民、坚毅而阳光的个体</p>
			</div>
		</div>
		<div class="team">
			<div class="abouttitle">
				<h3>核心专业团队</h3>
				<img src="../assets/aboutus/core_professional_team.png" alt="">
			</div>
			<div class="team-cont">
				<div class="swiper-container swiper-team">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<div class="swiper-slide-pd">
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/wangwei.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>王伟女士</h3>
											<h5>伊顿国际教育集团董事长兼CEO</h5>
											<span class="line"></span>
										</div>
										<p>新加坡籍华裔教育管理专家，现任Etonkids（北京伊顿国际幼儿园）董事长兼首席执行官（CEO）。王伟女士毕业于全球排名顶尖的美国西北大学 (Northwestern Uni-versity) KELLOGG商学院，主攻市场、金融及会计专业，并获MBA学位。2002年王伟女士当选为 KELLOGG 商学院北京校友会主席并在同年回国创办了Etonkids（北京伊顿国际幼儿园），并将Etonkids发展成为了中国最优秀的国际教育品牌之一。</p>
										<!-- <p>KA儿童之家作为Etonkids的旗下品牌，自创立以来，KA积极追求进取和卓越，汇聚众多国内外知名教育专家和致力于投身教育事业的优秀互联网人才，并不断通过加强师资力量、培训、运营管理水平以及提升信息化系统来提高整体的教学及服务质量。作为幼教从业者，我们不仅在教育今天的孩子，更承载为更多的孩子创造更美好未来的使命，希望KA儿童之家在未来能成为全球最具价值的幼教品牌、最具权威的幼教机构。</p> -->
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/kangyan.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>康雁先生</h3>
											<h5>伊顿国际教育集团联合创始人</h5>
											<span class="line"></span>
										</div>
										<p>康雁先生，同时任Etonkids总裁，拥有美国耶鲁大学商学院MBA学位，清华大学文学学士和工学学士双学位。曾任汽车之家总裁，在此后的16个月内成功主导了汽车之家转型，实现了汽车之家股价200%的增长。曾在战略咨询企业贝恩公司和罗兰贝格公司分别担任全球高级合伙人职务。</p>
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/zhangtan.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>张谭先生</h3>
											<h5>KA儿童之家营销副总裁</h5>
											<span class="line"></span>
										</div>
										<p>张潭先生，曾在中国最大的汽车互联网平台汽车之家担任区域营销部总经理，期间带领百余人团队帮助汽车之家多次实现销售业绩增幅，对市场营销和团队管理拥有十几年的理论和实践的积累。</p>
									</dd>
								</dl>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="swiper-slide-pd">
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/paul.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>Dr.Paul Epstein 先生</h3>
											<h5>蒙台梭利教师培训学术总监</h5>
											<span class="line"></span>
										</div>
										<p>Paul是著名的培训大师和国际演说家，国际蒙台梭利专家，曾任特兰西瓦尼亚大学副教授和西北大学兼职教授。他向教育工作者和家长们提供了具有改革意义的学习经验与方法。他很感激自己的工作能够有大量的机会去观察孩子与家长，这些经历和数据也激发了他的灵感。</p>
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/julie_wood.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>Julie Wood 女士</h3>
											<h5>KA儿童之家学术顾问</h5>
											<span class="line"></span>
										</div>
										<p>Wood博士拥有哈佛大学科技教育创新硕士学位和语言与阅读方向的教育博士学位。作为Etonkids和KA儿童之家的专家团成员，Wood博士将会对KA的国际英文课程和STEAM课程研发提供指导。</p>
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/bill.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>Bill Boland 先生</h3>
											<h5>KA儿童之家研发副总裁</h5>
											<span class="line"></span>
										</div>
										<p>来自纽约雪城的教育工作者、电影制作人和作家，毕业于美国南加州大学电影电视制作专业，硕士就读于亚利桑那州立大学幼儿教育课程与教育指导专业，已获得美国贝塞尔大学PYP IB教师资格，目前在约翰·霍普金斯大学教育学院攻读教育科技方向的博士学位。他参与制作的短片电影《西岸故事》曾获得2007年奥斯卡最佳真人短片奖。</p>
									</dd>
								</dl>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="swiper-slide-pd">
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/william.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>William Ordonez 先生</h3>
											<h5>KA儿童之家创意设计部总监</h5>
											<span class="line"></span>
										</div>
										<p>美国林林艺术设计学院美术专业学士，同时辅修摄影艺术专业。目前主要负责KA儿童之家内部插图、设计、影视拍摄和剪辑等监管工作。加入KA前在Etonkids担任了3年的创意设计经理，以及5年的教育工作者职务，为二十余本幼儿图书（多数可在亚马逊上购买）设计了插图，并为《Beijing Kids》 和《City Weekend 》两本杂志撰写了数篇文章。</p>
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/chenyanlai.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>陈雁莱 女士</h3>
											<h5>KA儿童之家创意及艺术总监</h5>
											<span class="line"></span>
										</div>
										<p>伦敦艺术大学中央圣马丁艺术与设计学院硕士，国内知名动画导演，现任KA儿童之家创意及艺术总监，曾任万达集团美术主任工程师，其创作的独立动画短片《我的海螺记忆》荣获二十四项国际电影节奖项和荣誉（其中包括四项奥斯卡认证电影节的荣誉），专注于儿童美术以及儿童绘画心理学研究及创作多年。</p>
									</dd>
								</dl>
								<dl class="swiper-slide-list">
									<dt><img src="../assets/aboutus/fanpeifen.png" alt=""></dt>
									<dd>
										<div class="swiper-slide-title">
											<h3>范佩芬 女士</h3>
											<h5>KA儿童之家学术顾问</h5>
											<span class="line"></span>
										</div>
										<p>范佩芬老师从事学前教育工作四十多年，担任园长近三十年，将蒙台梭利教育和中国的教育进行了融合式的探索研究，她是第一批亲赴美国接受蒙台梭利培训的教育专家，也是蒙台梭利教育理念在中国实践的标杆性人物。2010年受聘为中国蒙台梭利专家协会任副会长。</p>
									</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
		</div>
		<div class="contact">
			<div class="abouttitle">
				<h3>联系我们</h3>
				<img src="../assets/aboutus/contact_us.png" alt="">
			</div>
			<div class="contact-map">
				<img src="../assets/aboutus/map.jpg" alt="">
			</div>
			<div class="contact-center">
				<ul class="contact-type">
					<li>
						<img src="../assets/news/newsdetails_02.png" alt="">
						<p>北京市朝阳区酒仙桥东路<br>电子城区M8楼A5层</p>
					</li>
					<li>
						<img src="../assets/news/newsdetails_03.png" alt="">
						<p></p>
					</li>
					<li>
						<img src="../assets/news/newsdetails_04.png" alt="">
						<p>sales@kidsacademy.com</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="news">
			<div class="abouttitle">
				<h3>最新动态</h3>
				<img src="../assets/aboutus/news.png" alt="">
			</div>
			<div class="news-cont">
				<div class="news-mar">
					<dl class="news-list" v-for="(item, index) in newslist" :key="index" @click="goNewsDetails(item, item.id)">
						<dt><img :src="item.url" alt=""></dt>
						<dd>
							<h4 :title="item.title">{{item.title}}</h4>
							<p>{{item.txt | ellipsis}}</p>
							<span>{{item.date}}</span>
						</dd>
					</dl>
				</div>
				<router-link to="/news" class="news-more">查看更多 >></router-link>
			</div>
		</div>
		<div class="aveuheight"></div>
		<div class="aveu">
			<div class="aveu-cont">
				<div class="aveu-logo"><img src="../assets/aboutus/aveu_logo.png" alt=""></div>
				<div class="aveu-banner">
					<h4>AVEU反暴力教育联盟</h4>
					<p>守护孩子唯一的童年</p>
					<p>3分钟让孩子学会保护自己，远离暴力侵害</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {AboutUsNews} from '../data/data.js'
	export default {
		name: 'AboutUs',
		data () {
			return {
				len: 50,
				newslist: []
			}
		},
		mounted(){
			new Swiper ('.swiper-team', {
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
			 })
			 this.newslist = AboutUsNews
		},
		methods: {
			goNewsDetails:  function(item, id) {
				this.$router.push({path: '/news/:id',name: '新闻资讯详情', params: {id: id}})
				document.title = item.title
			}
		},
		filters: {
			ellipsis(txt) {
				if(!txt) return ''
				if(txt.length>52) {
					return txt.slice(0,52)+'...'
				}
				return txt
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.content {
		padding-top: 210px;
		background: url(../assets/partner/bg.jpg) center top repeat-y;
		color: #091338;
		.abouttitle {
			text-align: center;
			h3 {
				font-weight: normal;
				font-size: 28px;
				color: #1c50a1;
			}
		}
	}
	.intro {
		.abouttitle{
			margin-bottom: 20px;
			h3 {
				margin-bottom: 10px;
			}
		}
		&-cont {
			// height: 304px - 30px;
			padding-top: 16px;
			padding-bottom: 22px;
			background: #f5f5f6;
			&-txt {
				float: right;
				width: 524px;
				padding-top: 30px;
				margin-right: 16px;
				p {
					margin-bottom: 16px;
					text-align: justify;
					line-height: 18px;
					font-size: 14px;
				}
			}
		}
		.cwidth {
			@extend %clearfix;
		}
	}
	.story {
		height: 752px - 68px;
		padding-top: 68px;
		background: url(../assets/aboutus/story_bg.jpg) center top no-repeat;
		.abouttitle {
			margin-bottom: 24px;
			h3 {
				margin-bottom: 5px;
			}
		}
		&-cont {
			@extend %clearfix;
			@extend %width;
			&-l {
				float: left;
				width: 530px;
				h4, p {
					text-align: right;
				}
			}
			&-r {
				float: right;
				width: 530px;
				padding-top: 115px;
			}
			.l-one {
				height: 240px;
			}
			.l-two {
				height: 215px;
			}
			.r-one {
				height: 244px;
			}
// 			.r-two {
// 				height: 110px;
// 			}
			h4 {
				margin-bottom: 8px;
				line-height: 28px;
				font-weight: normal;
				font-size: 24px;
			}
			p {
				line-height: 20px;
				font-size: 14px;
			}
		}
	}
	.adv {
		height: 535px;
		background: url(../assets/aboutus/adv_bg2.jpg) center top no-repeat;
		.abouttitle {
			h3 {
				margin-bottom: 5px;
			}
		}
		&-cont {
			@extend %clearfix;
			@extend %width;
			padding-top: 16px;
			&-l {
				float: left;
				margin-left: 95px;
			}
			&-r {
				float: right;
				margin-right: 20px;
			}
			&-l,
			&-r{
				// width: 50%;
				// text-align: center;

				li {
					position: relative;
					text-align: center;
					img {
						position: absolute;
						// transition: all ease-out .35s;

					}
					.pos1 {
						left: 160px;
						top: -40px;
					}
					.pos2 {
						left: 140px;
						top: 20px;
					}
					.pos3 {
						left: 140px;
						top: 15px;
					}
					.pos4 {
						left: 140px;
						top: 20px;
					}
					p {
						text-align: left;
						font-size: 18px;
						color: #091338;
					}
					&:hover {
						img {
							animation-name: bounce;
							animation-duration: 1s;
							animation-fill-mode: both;
							transform-origin: center bottom;
						}
					}
				}
				.font-red {
					padding-top: 36px;
					span {
						font-size: 24px;
						color: #e42e3c;
					}
				}
				.font-blue {
					padding-top: 98px;
					span {
						font-size: 24px;
						color: #122754;
					}
				}
				.font-yellow {
					padding-top: 92px;
					span {
						font-size: 24px;
						color: #c7911a;
					}
				}
				.font-purple {
					padding-top: 96px;
					span {
						font-size: 24px;
						color: #8c5ed3;
					}
				}
			}

		}
	}
	.concept {
		height: 435px - 30px;
		padding-top: 30px;
		background: url(../assets/aboutus/concept_bg.jpg) center top no-repeat;
		text-align: center;
		color: #fff;
		.abouttitle {
			margin-bottom: 10px;
			h3 {
				margin-bottom: 5px;
				color: #fff;
			}
		}
		h5 {
			font-weight: normal;
			font-size: 18px;
		}
		p {
			margin-bottom: 30px;
			font-size: 16px;
			@include opacity(75);
		}
		.font18 {
			font-size: 18px;
		}
		&-thrc {
			margin-bottom: 50px;
			h5 {
				margin-bottom: 35px;
			}

		}
		&-five {
			h5 {
				margin-bottom: 28px;
			}
		}
	}
	.team {
		height: 776px - 54px;
		padding-top: 54px;
		background: url(../assets/aboutus/team_bg.jpg) center top no-repeat;
		&-cont {
			@extend %width;
			position: relative;
			.swiper-slide {
				&-pd {
					padding: 45px 0 0 20px;
					@extend %clearfix;
				}
				&-list {
					float: left;
					width: 264px;
					margin: 0 22px;
					color: #fff;
					h3,
					h5 {
						text-align: center;
						font-weight: normal;
					}
					h3 {
						margin-bottom: 10px;
						font-size: 22px;
					}
					h5 {
						margin-bottom: 20px;
						font-size: 16px;
					}
					p {
						text-align: justify;
						line-height: 24px;
						font-size: 14px;
					}
					img {
						width: 95px;
						height: 96px;
						border-radius: 50%;
						display: block;
						margin: 0 auto 18px;
					}
					.line {
						display: block;
						margin: 0 auto 18px;
						width: 125px;
						height: 1px;
						background: #fff;
					}
				}
			}
		}
		.abouttitle{
			margin-bottom: 48px;
			h3 {
				margin-bottom: 6px;
			}
		}
		.swiper-team {
			width: 970px;
			height: 545px;
			margin: 0 auto;
			background: url(../assets/aboutus/55490938_l.jpg) left top no-repeat;
		}
	}
	.contact {
		margin-bottom: 50px;
		background: url(../assets/partner/bg.jpg) center top repeat-y;
		.abouttitle {
			margin-bottom: 48px;
			h3 {
				margin-bottom: 5px;
			}
		}
		&-map {
			margin-bottom: 52px;
			text-align: center;
			img {
				width: 100%;
			}
		}
		&-center {
			@extend %width;
			text-align: center;
		}
		&-type {
			@extend %clearfix;
			display: inline-block;
			li {
				float: left;
				width: 200px;
				margin: 0 33px;
				text-align: center;
				font-size: 16px;
				color: #091338;
				&:hover {
					img {
						animation-name: bounce;
						animation-duration: 1s;
						animation-fill-mode: both;
						transform-origin: center bottom;
					}
				}
				img {
					width: 80px;
					height: 80px;
				}
				p {
					padding-top: 25px;
					line-height: 20px;
				}
			}
		}
	}
	.news {
		padding-top: 45px;
		padding-bottom: 54px;
		background: #f5f5f6;
		.abouttitle {
			margin-bottom: 30px;
			h3 {
				margin-bottom: 10px;
			}
		}
		&-cont {
			@extend %width;
		}
		&-mar {
			@extend %clearfix;
			margin-right: -60px;
		}
		&-list {
			float: left;
			width: 556px;
			height: 197px;
			background: #fff;
			border-radius: 8px;
			margin-right: 30px;
			margin-bottom: 30px;
			transition: all ease-out .35s;
			cursor: pointer;
			&:hover {
				box-shadow: 0 3px 12px rgba(205,204,204,.8);
				h4 {
					color: #e8374a;
				}
			}
			dt {
				float: left;
				width: 268px;
				height: 100%;
				border-radius: 8px;
				overflow: hidden;
				img {
					width: 268px;
					height: 197px;
					border-radius: 8px;
				}
			}
			dd {
				margin-left: 288px;
				margin-right: 20px;
				padding-top: 26px;
				padding-bottom: 8px;
				border-bottom: 1px solid #757575;
				font-size: 14px;
				color: #091338;
				h4 {
					width: 100%;
					margin-bottom: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-weight: normal;
					font-size: 18px;

				}
				p {
					height: 88px;
					overflow: hidden;
					line-height: 24px;
					text-align: justify;
				}
			}
		}
		&-more {
			display: block;
			margin: 0 auto;
			width: 120px;
			@include lh(40px);
			border-radius: 4px;
			border: 1px solid #e5364b;
			background: #e5364b;
			font-size: 14px;
			color: #fff;
			transition: all 0.35s ease-out;
			&:hover {
				border-color: #e5364b;
				background: #fff;
				color: #e5364b;
			}
		}
	}
	.aveuheight {
		height: 226px;
		width: 100%;
	}
	.aveu {
		width: 100%;
		height: 392px;
		background: url(../assets/aboutus/aveu_pic.png) center top no-repeat;
		position: absolute;
		left: 0;
		bottom: -165px;
		z-index: 0;
		&-cont {
			@extend %width;
			position: relative;
		}
		&-logo {
			position: absolute;
			left: 0;
			top: -20px;
			height: 215px;
			img {
				height: 100%;
			}
		}
		&-banner {
			padding-top: 70px;
			text-align: center;
			color: #fff;
			h4 {
				margin-bottom: 58px;
				letter-spacing: 2px;
				font-weight: normal;
				font-size: 24px;
			}
			p {
				@include opacity(75);
				margin-bottom: 14px;
				font-size: 14px;
			}
		}
	}
	.footerbar {
		position: relative;
		z-index: 9;
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue